module.exports = __webpack_public_path__ + "img/adx.06347dde.svg";